export default __webpack_public_path__ + "static/media/web_design.aef36559.jpg";